import { connect } from 'react-redux';
import { updateFilters } from 'common/gantt/containers/gantt-actions';
import PlanningBoardTop from '../components/planning-board-top';
import {
  getGanttViews,
  updateView,
  fetchBoardData,
  updateSort,
  setView,
} from '../../common/gantt/containers/gantt-actions';

const mapStateToProps = state => ({
  filterDefinitions: state.gantt.filterDefinitions,
  isLoadingBoardData: state.gantt.isLoadingBoardData,
  activeFilters: state.gantt.activeFilters,
  activeView: state.gantt.activeView,
  activeSort: state.gantt.activeSort,
  views: state.gantt.views,
  saveSuccess: state.gantt.saveViewsSuccess,
  range: state.gantt.view,
  planningAndViewToOpen: state.gantt.planningAndViewToOpen,
});

const mapDispatchToProps = {
  getGanttViews,
  updateFilters,
  updateView,
  updateSort,
  fetchBoardData,
  updatePeriod: setView,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanningBoardTop);
